<template>
  <div class="checkout">
    <Header/>
    <div class="container main clearfix">
      <Info :order="neworder"/>
      <Bonus :order="neworder" :product="product"/>
      <Note/>
      <Pay @changePayType="changePayType" :payType="payType"/>
      <button class="payButton" @click="Pay">确认支付</button>
    </div>
    <Footer/>
  </div>
</template>

<script>
import{encrypt,setCookie} from "@/utils"

import Header from "@/components/PC/Common/Header.vue";
import Footer from "@/components/PC/Common/Footer.vue";
import Info from "@/components/PC/Checkout/Info.vue";
import Bonus from "@/components/PC/Checkout/Bonus.vue";
import Note from "@/components/PC/Checkout/Note.vue";
import Pay from "@/components/PC/Checkout/Pay.vue";

export default {
  name: "Order",
  data() {
    return {
      active: 2,
      ordersn: {},
      checked: true,
      payType: "1",
      show: true
    };
  },
  components: {
    Header,
    Footer,
    Info,
    Note,
    Pay,
    Bonus
  },
  mounted: function() {
    window.scroll(0,0);
  },
  computed: {
    neworder() {
      return this.$store.state.order.neworder;
    },
    product() {
      return this.$store.state.product.product;
    },
    payUrl() {
      return this.$store.state.alipay.alipayurl;
    },
    WechatWap() {
      return this.$store.state.wechat.wechatwap;
    }
  },
  methods: {
    Pay() {
      // this.$confirm(
      //   "请在新页面完成付款,如付款遇到问题请致电:0755-33528888",
      //   "付款完成请请勿关闭页面",
      //   {
      //     confirmButtonText: "支付成功",
      //     cancelButtonText: "用户中心",
      //     type: "warning",
      //     showClose: false,
      //     closeOnClickModal: false
      //   }
      // )
      //   .then(() => {
      //     window.location.href="https://www.suhuishou.com/pc/#/user"; 
      //   })
      //   .catch(() => {
      //     window.location.href="https://www.suhuishou.com/pc/#/user"; 
      //   });
      if (this.payType == "1") {
        this.WechatPay();
      } else {
        this.AliPay();
      }
    },
    AliPay() {
      let params = {
        ordersn: this.neworder.ordersn,
        amount: this.neworder.amount,
        goodsName: this.neworder.goodsname
      };
      this.$store.dispatch("alipay/fetchAlipayUrl", { params }).then(() => {
        console.log(this.payUrl);
        // window.open(this.payUrl, "_blank");
        const div = document.createElement("div");
        div.innerHTML = this.payUrl;
        document.body.appendChild(div);
        document.forms[0].submit();
      });
    },
    WechatPay() {
      let params = {
        ordersn: this.neworder.ordersn,
        amount: this.neworder.amount,
        goodsName: this.neworder.goodsname,
        goodsId: this.neworder.goodsid
      };
      let _this = this;
      this.$store.dispatch("wechat/fetchWechatScheme", { params }).then(() => {
        let data = _this.$store.state.wechat.wechatscheme;
        if (data.result_code == "SUCCESS") {
          let scheme = JSON.stringify(data);
          setCookie("scheme", encrypt(scheme), true);
          let routeData = this.$router.resolve({
            name: "wechatScheme",
          });
          window.open(routeData.href, "_blank");
        } else {
          window.location.href="https://www.suhuishou.com/pc/#/user"; 
        }
      });
    },
    changePayType(value) {
      this.payType = value;
    }
  },
  created() {}
};
</script>
<style>
.checkout {
  background: #efefef;
}
.checkout .footer {
  margin-top: 0 !important;
}
.checkout .productBonus {
  display: flex;
  padding: 20px 20px;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin: 10px 0;
  border-radius: 4px;
  position: relative;
}
.checkout .productBonus p:nth-child(1) span {
  color: #f9415d;
}
.checkout .bonusChecked {
  position: absolute;
  right: 20px;
  top: 20px;
}
.checkout .prouctFooter {
  /*  display: flex;
  height: 60px;
  padding:0 20px;
  background: #fff;
  margin-top: 20px;*/
}
.checkout .footerLeft {
  width: 800px;
  line-height: 60px;
}
.checkout .footerLeft span {
  color: #888;
  margin-right: 50px;
}
.checkout .footerLeft em {
  color: #000;
  font-style: normal;
  margin-left: 5px;
}
.checkout .footerRight {
  /*width: 426px;*/
  text-align: right;
}
.checkout .footerRight div {
  float: right;
  margin-right: 50px;
  line-height: 60px;
}
.checkout .footerRight div span {
  /* color: #f9415d; */
  /* font-size: 24px; */
}
.checkout .footerRight div em {
  font-style: normal;
  font-size: 14px;
}
.checkout .footerRight button {
  float: right;
  display: inline-block;
  background: #f9415d;
  border: 0;
  color: #fff;
  height: 60px;
  padding: 0 50px;
  margin-right: -20px;
}
.checkout .payButton {
  float: right;
  display: inline-block;
  background: #f9415d;
  box-shadow: #f9415d 0 0 5px; 
  border: 0;
  color: #fff;
  height: 40px;
  padding: 0 50px;
  margin: 20px 0;
  border-radius: 50px;
}
</style>
